(function() {
	'use strict';

	angular.module('app.core')
	.service('userAttributes', userAttributesService);

	var defaults = {
		'priltNewLink': 1, // whether to show new link warning modal for drilldown on prilt widget
		'metricDrilldownColumn': 'dateSort',
		'metricDrilldownColumnDir': 'ASC',
		'showNewSupplyReports': 1,
		'addSupplyDemandRows': 0,
		'includeTotalRows' : 0,
		'hotSheetTrigger': 0
	};

	var attributes;

	function userAttributesService($http, URLS, $sha) {
		attributes = _.defaults(globalConfig.user.attributes, defaults);

		$sha.setConfig({
			algorithm: 'SHA-256',
			inputType: 'TEXT',
			returnType: 'B64'
		});

		return {
			set: set,
			get: get,
			setHashed: setHashed,
			getHashed: getHashed,
			hashKey: hashKey
		};

		/**
		 * get value of a single attribute, or a dictionary of all attributes
		 * which are set, if no attribute name is passed.
		 *
		 * @param String attribute
		 */
		function get(attribute) {
			if (attribute) {
				return attributes[attribute];
			} else {
				return _.clone(attributes);
			}
		}

		/**
		 * Set one or more values. The patch parameter is a dictionary of
		 * attributes which will be set.
		 *
		 * Returns the dictionary of current values for all attributes after
		 * changes were applied.
		 *
		 * @param {*} patch
		 * @param boolean isGlobal
		 */
		function set(patch, isGlobal) {
			var url = URLS.host + URLS.userAttributes;
			var params = { global: !!isGlobal };
			return $http.patch(url, patch, { params: params }).then(function(result) {
				attributes = _.defaults(result.data, defaults);
				globalConfig.user.attributes = attributes;
				return attributes;
			});
		}

		/**
		 * get a single attribute using sha256 to shorten the attribute
		 * name. Length is the number of characters to use for attribute
		 * hash and defaults to 6. This must match the length used when
		 * the attribute was set.
		 *
		 * @param String prefix
		 * @param String key
		 * @param int length
		 */
		function getHashed(prefix, key, length) {
			return get(prefix + '_' + hashKey(key, length));
		}

		/**
		 * Set a single attribute using sha256 to shorten the attribute
		 * name. hashLength is the number of characters to use for attribute
		 * hash and defaults to 6.
		 *
		 * @param String prefix
		 * @param String key
		 * @param int length
		 * @param { hashLength: int, isGlobal: boolean } options
		 */
		function setHashed(prefix, key, value, options) {
			options = _.defaults(options, { hashLength: 6, isGlobal: 1 });
			var key = prefix + '_' + hashKey(key, options.hashLength);
			var patch = {};
			patch[key] = value;
			return set(patch, options.isGlobal);
		}

		function hashKey(key, length) {
			length = length || 6;
			return $sha.hash(key).substring(0, length);
		}
	}
})();
